import { differenceInCalendarDays, parse, parseISO, startOfDay } from 'date-fns'
import { DateFormat } from '@/scopes/common/domain/types'

export function toUTCDay(date: Date) {
  const utcDate = new Date(0)
  utcDate.setUTCFullYear(date.getFullYear(), date.getMonth(), date.getDate())
  utcDate.setUTCHours(0, 0, 0, 0)
  return utcDate
}

/**
 *  Parses a date (without time) from a string using the provided
 *  format and converts it to UTC to avoid timezone issues.
 */
export function parseDay(dayDateAsString: string, format: DateFormat) {
  const parsed = parse(dayDateAsString, format, new Date())

  return toUTCDay(parsed)
}

export function parseDateForLocalFormatting(dateString: string): Date {
  return /^\d{4}-\d{2}-\d{2}$/.test(dateString)
    ? new Date(`${dateString}T00:00:00`)
    : new Date(dateString)
}

export function isValidDate(date: Date) {
  return !Number.isNaN(date.getTime())
}

export function isDatePast(dateString: string, now: Date = new Date()): boolean {
  if (!dateString)
    return false
  const parsed = parseISO(dateString)
  if (!isValidDate(parsed))
    return false
  return differenceInCalendarDays(startOfDay(parsed), startOfDay(now)) < 0
}
